<template>
  <drag-and-drop />
</template>

<script>
import DragAndDrop from '../components/ColdChainComponents/DragAndDropComponent.vue'
export default {
  components: {
    DragAndDrop
  }
}
</script>

<style scoped>
</style>
